const ImgRadioButton = (props) => {
  return (
    <>
      <label className="input-box">
        <input
          type="radio"
          name={props.name}
          value={props.value}
          {...(!props.checked ? { checked: props.checked } : {})}
          onChange={props.handleOptionChange}
        />

        <img src={props.src} alt={props.alt} className="centered-img"/>
      </label>{" "}
    </>
  );
};

export default ImgRadioButton;
